import * as React from "react";
import { gql, useQuery } from "@apollo/client";
import {
  ViewCategoryPwaQueryQuery,
  ViewCategoryPwaQueryQueryVariables,
} from "../../../schemaTypes";

export const viewCategoryPWAQuery = gql`
  query ViewCategoryPWAQuery($id: String!) {
    viewCategoryPWA(id: $id) {
      id
      name
      imgSrc
      # createdBy {
      #   id
      #   role
      #   admin {
      #     id
      #     firstname
      #     lastname
      #     level
      #   }
      # }
      isArchive
      createdAt
    }
  }
`;

export interface WithViewCategoryPWA {
  category: ViewCategoryPwaQueryQuery["viewCategoryPWA"] | null;
  loading: boolean;
}

interface Props {
  categoryId: string;
  children: (data: WithViewCategoryPWA) => React.ReactElement | null;
}

export const ViewCategoryPWA: React.FC<Props> = ({ categoryId, children }) => {
  const { data, loading } = useQuery<
    ViewCategoryPwaQueryQuery,
    ViewCategoryPwaQueryQueryVariables
  >(viewCategoryPWAQuery, {
    variables: { id: categoryId },
  });

  let category: ViewCategoryPwaQueryQuery["viewCategoryPWA"] | null = null;
  if (data && data.viewCategoryPWA) {
    category = data.viewCategoryPWA;
  }

  return children({
    category,
    loading,
  });
};
